import React, { Component } from "react";
import { connect } from "react-redux";
import Product from "./Product";
import Category from "../GridView/Category";
import CategoryV2 from "../GridView/CategoryV2";
import Collapsible from "react-collapsible";

import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

class CategoryDetailList extends Component {
  render() {
    const { language, settings, selectedCategoryID } = this.props;
    const storeLayout = this.props.settings.store_layout;
    let products;
    let subCategories;
    let selectedCategory;

    try {
      selectedCategory = this.props.category;
      if (!selectedCategory.products?.length && !selectedCategory.has_children)
        return <></>;

      if (!selectedCategory.has_children) {
        let tempProducts = selectedCategory.products;

        products = tempProducts.map((product) => (
          <Product
            category_id={selectedCategory.id}
            key={
              "gird_category_item " +
              product.name +
              " " +
              product.id +
              parseInt(Math.random() * 1000)
            }
            product={product}
          />
        ));
      } else {
        subCategories = this.props.categories.filter((cat) =>
          selectedCategory.sub_categories.includes(cat.id)
        );
        if (!subCategories.length) return <></>;
        subCategories = subCategories.map((category, indx) => (
          <CategoryV2
            key={"Grid_Category2 " + category.name + category.id}
            image={
              category.photo_medium
                ? category.photo_medium
                : category.photo
                ? category.photo
                : null
            }
            name={language == "english" ? category.name : category.ar_name}
            numberOfProducts={category.products_count}
            min_order={category.minimum_order_value}
            settings={this.props.settings}
            slug={category.slug}
            history={this.props.history}
            language={language}
          />
        ));
      }
    } catch (err) {
      this.props.history.replace("/");
      return null;
    }

    const hasCoverPhoto =
      selectedCategory?.cover_photo_large || selectedCategory?.cover_photo
        ? true
        : false;

    return (
      <div
        className=""
        style={{
          backgroundColor: "white",
          overflowY: "scroll",
          paddingBottom: 10,
          transition: "all 2s ease-in",
        }}
      >
        <Collapsible
          transitionTime={200}
          // triggerDisabled={this.props.selectedCategoryID}
          open={
            this.props.settings.collapsed_by_default &&
            !this.props.selectedCategoryID
              ? false
              : true
          }
          trigger={
            <>
              <div>
                {hasCoverPhoto && (
                  <div style={{ padding: 15 }}>
                    <div
                      style={{
                        width: "100%",
                        height: "clamp(180px, 25vw, 270px)",
                      }}
                    >
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: 5,
                        }}
                        src={
                          selectedCategory.cover_photo_large ||
                          selectedCategory.cover_photo
                        }
                      ></img>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="mx-auto bold"
                style={{
                  background: "#7777771f",
                  height: 50,
                  color: "#78828a",
                  textAlign: "center",
                  display: "grid",
                  alignItems: "center",
                  width: "98%",
                  borderRadius: 5,
                  marginTop: 10,
                  marginBottom: 20,
                  transform: "scale(0.983)",
                  cursor: !this.props.selectedCategoryID
                    ? "pointer"
                    : "default",
                }}
                id={"navigate" + this.props.category?.id}
              >
                <div>
                  {!this.props.selectedCategoryID && (
                    <ArrowDropDownIcon
                      style={{ position: "relative", top: -2 }}
                    />
                  )}
                  {language == "english"
                    ? selectedCategory.name
                    : selectedCategory.ar_name}
                </div>
              </div>
            </>
          }
        >
          {!selectedCategory.has_children ? (
            <div
              className="row mx-auto m-0"
              style={{
                backgroundColor: "white",
                width: settings.product_per_row ? "350px" : "98%",
                backgroundColor: "white",
              }}
              dir={language == "english" ? "ltr" : "rtl"}
            >
              {products}
            </div>
          ) : (
            <div
              className={"row text-center justify-content-between m-0 w-100 ".concat(
                storeLayout == "grid2" ? "px-1" : ""
              )}
              dir={language == "english" ? "ltr" : "rtl"}
              style={{ transform: "scale(0.983)" }}
            >
              {subCategories}
            </div>
          )}
        </Collapsible>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    categories: state.store.store.categories,
    cart: state.cart,
    settings: state.store.store.settings,
    discounts: state.cart.discounts,
    applied_promos: state.cart.smart_promos,
    categoryLoading: state.store.categoryLoading,
    selectedCategoryID: state.selectedCategoryHeader.selectedCategory?.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    removeCategoryPassword: (category_id) =>
      dispatch({ type: "REMOVE_CATEGORY_PASSWORD", payload: category_id }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CategoryDetailList);
